import React from 'react';
import { Typography } from 'antd';
import { MobileOutlined, SearchOutlined } from '@ant-design/icons';

import { colorForBackgroundColor } from '../../utils/RGBColorToHex';

import { useTeamMembers } from './useTeamMembers';

const { Text, Title } = Typography;

const TeamPagePreview = ({ team, teamId }) => {
  const {
    teamName,
    topLogo,
    rgbColor = '#FF0098',
    teamTapBehaviour = 'both',
  } = team || {};

  const members = useTeamMembers(teamId);
  const visibleMembers = (members || []).filter((member) => !member?.isDeleted);

  const showTeam = teamTapBehaviour === 'team' || teamTapBehaviour === 'both';
  const showMembers = teamTapBehaviour === 'members' || teamTapBehaviour === 'both';
  const contrastColor = colorForBackgroundColor(rgbColor);

  return (
    <div style={{ 
      position: 'sticky', 
      top: '24px', 
      width: '100%', 
      maxWidth: '320px',
      margin: '0 auto' 
    }}>
      <div style={{ 
        textAlign: 'center', 
        marginBottom: '12px', 
        color: '#8c8c8c', 
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        fontWeight: 'bold'
      }}>
        <MobileOutlined /> Team Page Preview
      </div>
      
      <div style={{ 
        background: '#000000', 
        borderRadius: '40px',
        border: '12px solid #1A1A1A',
        boxShadow: '0 30px 60px rgba(0,0,0,0.8)',
        overflowY: 'auto',
        minHeight: '560px',
        maxHeight: 'min(820px, 75vh)',
        aspectRatio: '9 / 19.5',
        width: '100%',
        maxWidth: '320px',
        margin: '0 auto',
        position: 'relative'
      }}>
        <div style={{
          background: rgbColor,
          textAlign: 'center',
          color: contrastColor
        }}>
          {topLogo && (
            <div style={{ padding: '16px 16px 0', textAlign: 'center' }}>
              <img
                src={topLogo}
                alt="Banner"
                style={{
                  maxWidth: '100%',
                  maxHeight: '90px',
                  width: 'auto',
                  height: 'auto',
                  display: 'block',
                  margin: '0 auto',
                  borderRadius: '8px',
                }}
              />
            </div>
          )}
          <div style={{ padding: topLogo ? '12px 16px 20px' : '28px 16px 20px' }}>
            <div style={{ fontSize: '13px', opacity: 0.8 }}>Leave a tip for</div>
            <Title level={4} style={{ color: contrastColor, margin: '6px 0 0', fontSize: '20px', fontWeight: '700' }}>
              {teamName || 'Your Team'}
            </Title>
            {showTeam && (
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
                <div style={{
                  background: '#ffffff',
                  color: '#000',
                  borderRadius: '999px',
                  padding: '12px 20px',
                  fontWeight: '600',
                  width: '100%',
                  textAlign: 'center',
                  border: `2px solid ${contrastColor}`
                }}>
                  Tip Whole Team
                </div>
              </div>
            )}
          </div>
        </div>

        <div style={{ padding: '20px 6px 40px' }}>
          {showMembers && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                <Text style={{ color: '#fff' }}>Select a team member</Text>
                <SearchOutlined style={{ color: '#fff' }} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px' }}>
                {visibleMembers.map((member) => (
                  <div key={member.clientId || member.displayName} style={{ background: '#1a1a1a', borderRadius: '12px', padding: '12px', textAlign: 'center' }}>
                    <div style={{ 
                      width: '64px', 
                      height: '64px', 
                      borderRadius: '50%', 
                      margin: '0 auto 8px', 
                      background: '#333', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      color: '#fff',
                      fontWeight: '600'
                    }}>
                      {member.avatar ? (
                        <img
                          src={member.avatar}
                          alt={member.displayName}
                          style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
                        />
                      ) : (
                        (member.displayName || 'Member')
                          .split(' ')
                          .map((n) => n[0])
                          .join('')
                      )}
                    </div>
                    <div style={{ color: '#fff', fontWeight: '600' }}>{member.displayName || 'Member'}</div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamPagePreview;
